import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientCharacteristicsHistory(patientId: string | undefined) {
  return useQuery(queries.patients.getPatientCharacteristicsHistory(patientId || ''))
}
